import { Box, Modal, ModalBody } from '@bechtel/gds';
import { FC } from 'react';
import { ModalCloseStyled, ModalHeaderStyled } from '~/styles/modal-styles';

interface ImagePreviewDialogProps {
  src: string;
  onClose: () => void;
  alt?: string;
}

const ImagePreviewDialog: FC<ImagePreviewDialogProps> = ({ src, onClose, alt }) => {
  return (
    <Modal visible={true} style={{ width: '450px', minHeight: '420px', maxHeight: '450px' }}>
      <ModalHeaderStyled title="Catalog Image">
        <ModalCloseStyled onClick={onClose}></ModalCloseStyled>
      </ModalHeaderStyled>
      <ModalBody>
        <Box justifyContent={{ sm: 'center' }} alignItems={{ sm: 'center' }} flexGrow={{ sm: 1 }} p={{ sm: '500' }}>
          <img src={src} alt={alt} style={{ maxWidth: '380px', maxHeight: '340px', minWidth: '200px' }} />
        </Box>
      </ModalBody>
    </Modal>
  );
};

export default ImagePreviewDialog;
